/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOffice = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M3 22V2h18v20zm14-8v6h2V4H5v16h2v-6zm-6 2H9v4h2zm4 0h-2v4h2zm-6-6v2H7v-2zm4 0v2h-2v-2zm4 0v2h-2v-2zM9 6v2H7V6zm4 0v2h-2V6zm4 0v2h-2V6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgOffice as Office };
